import { getRowClass } from 'helpers/cell';

export const getCompanyColumns = (columnsToHide, showContactOf) =>
  [
    {
      Header: 'Name',
      accessor: 'name',
      width: 200,
      disableSortBy: true,
      rowGroup: true,
      hide: true,
      pinned: 'left',
      cellRenderer: 'companyNameRenderer',
      suppressMovable: true,
      show: true,
      hideOnTableColumn: true,
    },
    {
      Header: 'Contact name',
      accessor: 'contactName',
      width: 320,
      disableSortBy: true,
      disablePadding: true,
      show: true,
      cellRenderer: 'contactNameRenderer',
      getRowClass,
    },
    {
      Header: 'Contact job title',
      accessor: 'jobTitle',
      width: showContactOf ? 280 : 490,
      disableSortBy: true,
      disablePadding: true,
      show: true,
      cellRenderer: 'companyRowRenderer',
      getRowClass,
    },
    ...(showContactOf
      ? [
          {
            Header: 'Contact of',
            accessor: 'contactOf',
            width: '280px',
            disableSortBy: true,
            disablePadding: true,
            cellRenderer: 'contactOfRenderer',
            show: showContactOf,
            getRowClass,
          },
        ]
      : []),
    {
      Header: 'Can you help?',
      accessor: 'offerIntro',
      width: 260,
      suppressMovable: true,
      resizable: false,
      disableSortBy: true,
      disablePadding: true,
      show: true,
      pinned: 'right',
      cellRenderer: 'introOfferRenderer',
      tooltipValueGetter: () => 'intro offer tooltip',
    },
  ].filter((column) => !columnsToHide.has(column.accessor));
